// Paths of the legal pages, without the locale prefix (LocalizedLink adds /en for English)
module.exports = {
  fr: {
    notice: '/mentions-legales/',
    privacy: '/confidentialite/',
    terms: '/cgu/',
    cookies: '/cookies/',
  },
  en: {
    notice: '/legal-notice/',
    privacy: '/privacy/',
    terms: '/terms/',
    cookies: '/cookies/',
  },
};
